// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductList_container__G2Zm6","pagerProgression":"ProductList_pagerProgression__MUZDW"};